import Vue from 'vue'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
import VuetableFieldSequence from "vuetable-2/src/components/VuetableFieldSequence.vue";
import numeral from 'numeral'
import i18n from '@/plugins/i18n';

function formatNumber(value) {
    return numeral(value).format("0,0");
}

function formatNumberDigit(value) {
    return numeral(value).format("0,0.00");
}

function formatNumber4Digit(value) {
    return numeral(value).format("0,0.0000");
}

export default [
    {
        name: "ch",
        title: i18n.t('Ch.'),
        width: "60px",
        dataClass: "vertical-align-top text-left"
    },
    {
        name: 'image',
        title: i18n.t('Image'),
        width: "60px",
        dataClass: "vertical-align-top text-left"
    },
    {
        name: 'product_name',
        title: i18n.t('Product Name'),
        width: "400px",
        dataClass: "vertical-align-top text-left"
    },
    {
        name: 'product_type',
        title: i18n.t('Product Type'),
        width: "150px",
        dataClass: "vertical-align-top",
        formatter: type => {
            switch (type) {
              case 'linked':
                  return '<span class="badge badge bg-info-800 mr-2 "style="min-width: 10px;"><i class="fas fa-link"></i>' + i18n.t(type) + '</span>';
                  break;
              case 'simple':
                  return '<span class="badge bg-primary-700 mr-2 "style="min-width: 10px;"><i class="fad fa-box-taped"></i>' + i18n.t(type) + '</span>';
                  break;
                
              default:
            }
        },
    },
    {
        id: 'warehouse_name',
        name: 'warehouse_name',
        title: i18n.t('Warehouse'),
        dataClass: "vertical-align-top",
    },
    {
        id: 'cost',
        name: 'cost',
        title: i18n.t('cost'),
        dataClass: "vertical-align-top",
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    },
    {
        id: 'stock_status',
        name: 'stock_status',
        title: i18n.t('Stock Status'),
        dataClass: "vertical-align-top",
    },
    {
        id: 'balance',
        name: 'balance',
        title: i18n.t('Available QTY'),
        dataClass: "vertical-align-top",
        formatter: (data) => {
            return formatNumber(data);
        }
    },
    {
        id: 'stock_alert',
        name: 'stock_alert',
        title: i18n.t('Minimum QTY'),
        dataClass: "vertical-align-top",
        formatter: (data) => {
            return formatNumber(data);
        }
    },
    {
        id: 'sold_last_12_months',
        name: 'sold_last_12_months',
        title: i18n.t('Sold Last 12 Months'),
        dataClass: "vertical-align-top",
        formatter: (data) => {
            return formatNumber(data);
        }
    },
    {
        id: 'average_sold_per_month',
        name: 'average_sold_per_month',
        title: i18n.t('Average Sold Per Month'),
        dataClass: "vertical-align-top",
        formatter: (data) => {
            let sum = data > 0 ? formatNumber(data) : '-';
            return sum ;
        }
    },
    {
        id: 'stock_in_month',
        name: 'stock_in_month',
        title: i18n.t('Stock In Month'),
        dataClass: "vertical-align-top",
        formatter: (data) => {
            let sum = data > 0 ? formatNumber(data) : '-';
            return sum ;
        }
    },
    {
        id: 'stock_value',
        name: 'stock_value',
        title: i18n.t('Stock Value'),
        dataClass: "vertical-align-top",
        formatter: (data) => {
            return formatNumberDigit(data);
        }
    }
];



// WEBPACK FOOTER //
// ./src/components/tenancy/admin/report/assets/js/Inventory_fields.js